import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { User } from '../types/users';

@Injectable({
  providedIn: 'root',
})
export class AuthUserService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/auth`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  signOnUser(user: {
    uid: string;
    firstName: string;
    lastName: string;
    email: string;
  }): Observable<User> {
    return this.http
      .post(this.urlRoute, user)
      .pipe(catchError(async (err) => this.onError(err)));
  }

  private onError(err: any): any {
    return (
      err?.error?.error_codes?.[0] ?? err?.error_codes?.[0] ?? err?.message
    );
  }
}
